import {
  LayoutContextProvider,
  LayoutName,
} from "components/context/LayoutContext";
import { LocalConfigContextProvider } from "components/context/LocalConfigContext";
import { ModalContextProvider } from "components/context/ModalContext";
import KeyboardShortcuts from "components/shared/KeyboardShortcuts";
import ThemeContainer from "containers/ThemeContainer";
import React from "react";
import { Provider as StoreProvider } from "react-redux";
import store from "store";

interface Props {
  children: React.ReactNode;
  layoutName?: LayoutName;
}

const App: React.FC<Props> = ({ children, layoutName }) => (
  <StoreProvider store={store}>
    <LocalConfigContextProvider>
      <KeyboardShortcuts />

      <ThemeContainer>
        <ModalContextProvider>
          <LayoutContextProvider name={layoutName}>
            {children}
          </LayoutContextProvider>
        </ModalContextProvider>
      </ThemeContainer>
    </LocalConfigContextProvider>
  </StoreProvider>
);

export default App;
